import React from "react";
import PropTypes from "prop-types";

import FullStoryCard from "cards/containers/FullStoryCard";

/**
 * Handles the logic to auto-expand the first story on a permalink stream.
 */
const PermalinkCard = props => (
  <FullStoryCard
    {...props}
    isOpen={props.index === 0}
    isPrimary={props.index === 0}
  />
);
PermalinkCard.fragments = FullStoryCard.fragments;

PermalinkCard.propTypes = {
  index: PropTypes.number,
};

export default PermalinkCard;
